export default __webpack_public_path__ + "media/images/features/ana/ogp-7a780d35bdc4ed2e5f0e5cab28515aab.jpg";